var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg39(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.72656C0.5 7.34687 0.782154 7.03307 1.14823 6.98341L1.25 6.97656L16.25 6.97656C16.6642 6.97656 17 7.31235 17 7.72656C17 8.10626 16.7178 8.42005 16.3518 8.46972L16.25 8.47656L1.25 8.47656C0.835786 8.47656 0.5 8.14078 0.5 7.72656Z",
    fill: "#706F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67003 2.23247C9.37651 1.94021 9.37549 1.46534 9.66775 1.17181C9.93344 0.904974 10.3501 0.879871 10.6441 1.09709L10.7284 1.16953L16.7784 7.19353C17.046 7.46002 17.0704 7.87813 16.8514 8.1722L16.7784 8.25643L10.7284 14.2814C10.435 14.5737 9.96008 14.5727 9.66779 14.2792C9.40208 14.0124 9.37873 13.5957 9.5972 13.3025L9.66999 13.2186L15.186 7.7247L9.67003 2.23247Z",
    fill: "#706F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg39);
export default __webpack_public_path__ + "static/media/svg39.8db55ceceb872d2ee58fd9054f508e71.svg";
export { ForwardRef as ReactComponent };